module.exports = __webpack_public_path__ + "static/img/partner-ef.c27066b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/partner/partner-ef.png
// module id = 5kGx
// module chunks = 34